"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNetworkStatus = exports.updateNetworkRTT = exports.updateConnectedStatus = exports.startBandwidthEstimator = exports.setBackendTerminated = void 0;
var types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var startBandwidthEstimator = () => ({
  type: types.START_BANDWIDTH_ESTIMATOR
});
exports.startBandwidthEstimator = startBandwidthEstimator;
var updateConnectedStatus = isConnected => ({
  type: types.UPDATE_NETWORK_CONNECTED,
  isConnected
});
exports.updateConnectedStatus = updateConnectedStatus;
var updateNetworkRTT = payload => ({
  type: types.UPDATE_NETWORK_RTT,
  payload
});
exports.updateNetworkRTT = updateNetworkRTT;
var updateNetworkStatus = payload => ({
  type: types.UPDATE_NETWORK,
  payload
});
exports.updateNetworkStatus = updateNetworkStatus;
var setBackendTerminated = () => ({
  type: types.SET_BACKEND_TERMINATED
});
exports.setBackendTerminated = setBackendTerminated;